import { contrastRatio, pickOnPrimaryColor } from '@/themes/colorUtils';
import { opaqueContrastBaseOf } from '@/themes/surfaceOpacity';

/**
 * WEB-1805 (живой случай Д48) — цвет надписи на кнопке принятия скидки.
 *
 * ЗАЧЕМ. 18.09 на денежном экране кнопка принятия скидки вышла БЕЛОЙ НАДПИСЬЮ
 * НА БЕЛОЙ ЗАЛИВКЕ (замерено вычисленным стилем: заливка rgb(255,255,255),
 * текст rgb(255,255,255)). Надпись была прибита строкой '#fff' независимо от
 * того, чем кнопку залили — акцентом темы или своим цветом автора. Покупатель
 * просто не видит предложение остаться.
 *
 * ПОЧЕМУ ОТДЕЛЬНЫЙ МОДУЛЬ. У этой кнопки ДВЕ двери: блок `downsell_offer` на
 * странице портала (DownsellOfferBlock.tsx) и карточка оффера на шаге
 * подтверждения отмены (CancelSubscriptionButton.tsx → CancelDownsellCard).
 * Автор красит оффер один раз, а разметок две — и прибитое '#fff' стояло в
 * обеих. Правило вынесено в одну запись, поэтому второго конца у него больше
 * нет по построению и сторожить нечего (WEB-1844).
 *
 * ПОЧЕМУ ТАК СЧИТАЕМ. Тот же приём, что у соседей по семье (пилюля-подпись,
 * плашка ошибки оплаты): сперва `opaqueContrastBaseOf` отсекает то, по чему
 * судить нечем — плёнку (сквозь неё видна страница) и неизмеримое
 * (`var(--…)`, незнакомое имя), — и только измеримая непрозрачная заливка
 * попадает в замер. Неизмеримое оставляет ИСТОРИЧЕСКИЙ белый: вид уже
 * выкаченных воронок не меняется.
 */
/** Исторический цвет надписи — ровно та строка, что стояла в обеих дверях. */
const HISTORIC_WHITE = '#fff';

/**
 * Ниже этого контраста белая надпись считается ПОТЕРЯННОЙ и пересчитывается.
 *
 * ПОЧЕМУ НЕ ДОМАШНЕЕ ПРАВИЛО ЦЕЛИКОМ. Общий помощник `pickOnPrimaryColor`
 * (порог яркости 0.179) на синей заливке по умолчанию `#1677ff` даёт ТЁМНУЮ
 * надпись: замер 23.09 — белое на ней 3.83:1, тёмное 4.5:1, то есть дом
 * формально прав. Но это перекрасило бы кнопку скидки на ВСЕХ уже выкаченных
 * воронках, где никакого дефекта нет и никто об этом не просил. Карточка про
 * потерянную надпись, а не про смену вида, поэтому белый держится, пока он
 * читается, и уступает только там, где он реально пропал: белое на белом — 1:1,
 * белое на `#fafafa` — 1.05:1.
 */
const WHITE_STAYS_ABOVE = 3;

export function offerCtaTextColor(background: string): string {
  const base = opaqueContrastBaseOf(background);
  if (!base) return HISTORIC_WHITE;
  if (contrastRatio('#ffffff', base) >= WHITE_STAYS_ABOVE) {
    return HISTORIC_WHITE;
  }
  return pickOnPrimaryColor(base);
}
